import { useEffect, useState } from 'react';

export function useRecentlyLoaded() {
	const [recentlyLoaded, setRecentlyLoaded] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => {
			setRecentlyLoaded(false);
		}, 1000);

		return () => {
			clearTimeout(timer);
		};
	}, []);

	return recentlyLoaded;
}
